import script from "./AuthLoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLoginForm.vue?vue&type=script&setup=true&lang=js"

import "./AuthLoginForm.vue?vue&type=style&index=0&id=380e36e0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380e36e0"]])

export default __exports__